import { ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

export const HEART_PATH = 'M12 20C14.205 19.518 21 15.7422 21 8.95371C21 7.4474 20.5 4.93688 17.5811 4.19033C16.5043 3.91492 14.4 3.58403 12 5.99413C9.6 3.58403 7.49565 3.91492 6.41886 4.19033C3.5 4.93688 3 7.4474 3 8.95371C3 15.7422 9.795 19.518 12 20Z';

function HeartFill({ size = ICON_DEFAULT_SIZE, color = 'var(--color-red)', ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d={HEART_PATH} fill={color}/>
        </svg>
    );
}

export default HeartFill;
